import styled from 'styled-components'

const Styled = styled.div`
.ant-table-thead > tr > th {
    background: white !important
}
`

export default Styled
